import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import levelBg from '../../assets/images/level_bg.png';

const StyledCurrentLevelContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	height: 100px;
	padding: 0 20px;
	background-image: url(${levelBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
`;

const StyledLevelContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 60px;
	height: 60px;

	${Text} {
		position: relative;
		z-index: 3;
		font-weight: 500;
		font-size: 24px;
		color: #ffffff;
	}
`;

const StyledSvg = styled.svg`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	.indicator {
		transform-origin: center;
		transform: rotate(90deg);
	}
`;

export { StyledCurrentLevelContainer, StyledLevelContainer, StyledSvg };
